import * as actionTypes from '../actions/actionTypes';

const intiData = {
  data: {
    otherAccounts: []
  },
  statuses: {
    basicDetails: {
      status: "incomplete"
    },
    eChannelContacts: {
      status: "incomplete"
    },
    accessControlAndLimit: {
      status: "incomplete"
    },
    productEnablements: {
      status: "incomplete"
    }
  }
};

export default function currentProductEchannelReducer(state = intiData, action) {
  switch(action.type){
    case actionTypes.SET_CURRENT_PRODUCT_ECHANNEL: {
      let newState = {...state};
      newState.data = action.productEchannelData;
      return newState;
    }
    case actionTypes.SET_CURRENT_PRODUCT_ECHANNEL_STATUSES: {
      let newState = {...state};
      newState.statuses = action.statuses;
      return newState;
    }
    case actionTypes.SET_E_CHANNEL_ACTIVE_TAB_INDEX: {
      let newState = {...state};
      newState.activeTabIndex = action.index;
      return newState;
    }
    case actionTypes.RESET_E_CHANNEL_ACTIVE_TAB_INDEX: {
      let newState = {...state};
      newState.activeTabIndex = 0;
      return newState;
    }
    case actionTypes.SET_CURRENT_PRODUCT_ACCOUNTS:{
      let newState ={...state};
      newState.currentProductAllAccounts = action.productEchannelAccountData
      return newState;
    }
    case actionTypes.SET_EXISTING_ENTITY_DATA:{
      let newState ={...state};
      newState.existingEntityData = action.existingEntityData
      return newState;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/currentProductEchannelReducer.js